import { Column } from 'components/v2/Column'
import FormLayout from 'components/v2/FormLayout'
import Heading from 'components/v2/Heading'
import { Row } from 'components/v2/Row'
import { INewPartnerStep3 } from 'features/Partners/types'
import { UserAutocomplete } from 'features/Users/components/UserAutocomplete'
import { getUserLabel } from 'features/Users/utils'
import { useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'

const messages = defineMessages({
  kamPlaceholder: {
    id: 'companies.new.form.kam.placeholder',
    defaultMessage: 'Enter KAM'
  }
})

export const ContactUrbvanFormCard = (): ReactElement => {
  const intl = useIntl()
  const { values, setFieldValue, setFieldTouched, touched, errors } = useFormikContext<INewPartnerStep3>()

  return (
    <FormLayout.Card small>
      <Heading.H4>
        <FormattedMessage id="partners.form.section.contactUrbvan.title" defaultMessage="Contact Urbvan by Kolors" />
      </Heading.H4>
      <Row noMargin>
        <Column width="50%">
          <UserAutocomplete
            label={<FormattedMessage id="newBusinessClientForm.kam.label" defaultMessage="KAM" />}
            placeholder={intl.formatMessage(messages.kamPlaceholder)}
            value={getUserLabel(values.kam)}
            onChange={(kam): void => {
              setFieldValue('kam', kam)
            }}
            onBlur={(): void => {
              setFieldTouched('kam.id', true)
            }}
            getItemLabel={getUserLabel}
            touched={touched.kam && touched.kam.id}
            errors={errors.kam && errors.kam.id}
          />
        </Column>
      </Row>
    </FormLayout.Card>
  )
}
